import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/reducer-main';
import { ProductWithPrice } from '../../../types/stripe';
import { useNavigate } from 'react-router';
import { AppDispatch } from '../../../store';
import PageLayout from '../../components/common/PageLayout';
import theme from '../../theme';
import logo from '../../../assets/wilma_care_welcome_logo.svg';
import gradientBg from '../../../assets/gradient_bg.svg'
import IconButton from '../../components/common/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Typography from '../../components/common/Typography';
import PlanCard from '../../components/PlanCard';
import { getStripeProductPerksFromMetadata } from '../../../helpers/stripeUtils';
import AdminDataFooter from '../../components/common/AdminDataFooter';
import { selectedPurchaseSessionProduct } from '../../../store/purchaseSession/slice';

export default function ProductsPage() {

  const {
    products,
    loadingProducts,
  } = useSelector((state: StoreState) => state.stripe);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const onProductSelect = (
    product: ProductWithPrice
  ) => {
    dispatch(selectedPurchaseSessionProduct(product));
    navigate('/auth/signup');
  }

  return (
    <PageLayout
      style={{
        padding: `${theme.sizing.x3} ${theme.sizing.x9}`,
        backgroundImage: `url(${gradientBg})`
      }}>
        <img src={logo} alt='Wilmacare' className="w-1/2 min-w-[200px] sm:w-1/2 md:w-1/3 lg:w-1/4 h-auto"/>
        <div className='flex flex-col items-center mt-10'>
          <div className='flex gap-4 justify-center items-center'>
            <IconButton 
              onClick={() => navigate('/auth/login')}
              icon={<ArrowBackIcon style={{color: theme.color.background}} />}/>
            <Typography 
              variant='headline2' 
              className='text-center'
              colorVariant='background'>
                Piani e prezzi
            </Typography>
          </div>
          <Typography
            variant='headline3' 
            className='text-center mt-7'
            colorVariant='background'>
            Tutti gli strumenti utili per la selezione di una badante riuniti in un’unica web app.
          </Typography>
          <Typography
            variant='display'
            className='text-center mt-4 w-3/4'
            colorVariant='background'>
              Calcola la percentuale di compatibilità tra la badante e la persona da assistere, archivia tutti i colloqui passati, fatti consigliare la persona più adatta
              tra quelle presenti nei tuoi archivi. Crea un database che ti permetta di velocizzare ed ottimizzare i tempi di ricerca.
          </Typography>
        </div>
        {
          products && (
            <div className='flex flex-1 justify-around mt-20'>
              {
                products.map(product => (
                  <PlanCard 
                    key={product.id}
                    planName={product.name}
                    onClick={() => onProductSelect(product)}
                    perks={getStripeProductPerksFromMetadata(product.metadata)}
                    price={`${((product.default_price.unit_amount ?? 0) / 100).toFixed(2).replace('.', ',')} €`}
                    planDescription={product.description}
                    style={{maxWidth: '27%' }} />
                ))
              }
            </div>
          )
        }
      <AdminDataFooter style={{marginTop: theme.sizing.x6}}/>
    </PageLayout>
  )
}